export const EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
export const phoneMask = {
	mask: ['S (###) ###-####', '(###) ###-####'],
	tokens: {
		S: {
			pattern: /1/,
		},
	},
	type: 'tel',
}
export const vinMask = {
	mask: 'HHHHHHHHHHHHHHHHH',
	tokens: {
		H: { pattern: /[A-HJ-NPR-Za-hj-npr-z\d]/, uppercase: true },
	},
}
export const plateMask = {
	mask: 'FFFFFFFFF',
	tokens: {
		F: {
			pattern: /.*/,
			uppercase: true,
		},
	},
}
export const zipMask = {
	mask: 'FFFFF',
	tokens: {
		F: {
			pattern: /\d/,
			uppercase: true,
		},
	},
}

export const getAssetUrl = (url: string): string => {
	return import.meta.env.PROD
		? `${import.meta.env.BASE_URL}${url.charAt(0) === '/' ? url.substring(1) : url}`
		: url
}

export const phoneMaskHelper = (val: string, target: HTMLInputElement) => {
	if (parseInt(val[val.length - 1]) >= 0 || parseInt(val[val.length - 1]) <= 0) {
	} else {
		if (val[val.length - 2] === ')') {
			target.setSelectionRange(target.value.length - 2, target.value.length - 2)
		} else if (val[val.length - 1] === '(') {
			return
		} else {
			target.setSelectionRange(target.value.length - 1, target.value.length - 1)
		}
	}
}
